// @flow
import React, { Fragment } from "react";
import Collapsible from "react-collapsible";
import ShippingIcon from "./AccordionIcons/ShippingIcon";
import MeasuringTapeIcon from "./AccordionIcons/MeasuringTapeIcon";

import "./Accordion.css";
import { getDangerousHtml } from "../../helpers/components";

const isEqual = str1 => str2 => str1 === str2;

type Props = {
  accordions: Array<any>
};

type State = {
  openAccordion: string,
  opening: boolean
};

class AccordionGroup extends React.Component<Props, State> {
  handleTriggerClick: Function;
  state = {
    openAccordion: "",
    opening: false
  };

  constructor(props: Props) {
    super(props);
    this.handleTriggerClick = this.handleTriggerClick.bind(this);
  }

  handleTriggerClick(title: string) {
    const { openAccordion, opening } = this.state;
    if (opening && openAccordion !== "") {
      return;
    }
    const isOpen = isEqual(openAccordion)(title);

    if (isOpen) {
      this.setState({
        openAccordion: "",
        opening: true
      });
    } else {
      this.setState({
        openAccordion: title,
        opening: true
      });
    }
  }

  onOpen() {
    this.setState({
      opening: false
    });
  }

  renderAccordionIcon(title) {
    const isShipping = title.toLowerCase().includes("ship");
    const isProductDetails = title.toLowerCase().includes("details");

    if (isShipping) {
      return <ShippingIcon />;
    } else if (isProductDetails) {
      return <MeasuringTapeIcon />;
    }
    return null;
  }

  render() {
    const { accordions } = this.props;
    return (
      <Fragment>
        {accordions.map(
          accordion =>
            accordion.title && (
              <Collapsible
                key={accordion.title}
                trigger={
                  <div className="PDPRedesign--ProductDetails-AccordionTitle">
                    {this.renderAccordionIcon(accordion.title)}
                    {accordion.title}
                  </div>
                }
                className="pdp-accordion"
                openedClassName="pdp-accordion pdp-accordion--open"
                handleTriggerClick={this.handleTriggerClick.bind(this, accordion.title)}
                open={isEqual(this.state.openAccordion)(accordion.title)}
                onOpen={this.onOpen.bind(this)}
              >
                <div
                  className="pdp-accordion__content"
                  dangerouslySetInnerHTML={getDangerousHtml(accordion.content)}
                />
              </Collapsible>
            )
        )}
      </Fragment>
    );
  }
}

export default AccordionGroup;



// WEBPACK FOOTER //
// ./src/components/AccordionGroup/index.js